import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'completed';

class CompletedService {
    create({parentId, type, answers}) {
        return axios
            .post(API_URL, {
                parentId: parentId,
                type: type,
                answers: answers
            }, {headers: authHeader() });
    }
    update({id, comment}) {
        return axios.put(API_URL, {
            id: id,
            comment: comment
        }, {headers: authHeader() });
    }
    delete(id) {
        return axios.delete(API_URL, {
            headers: authHeader(),
            data: {
                id: id
            }
        });
    }
    one(id) {
        return axios.get(API_URL + '/' + id, {headers: authHeader() })
    }
    all() {
        return axios.get(API_URL, {headers: authHeader() })
    }
    sendPdfToEmail(formData) {

        // Post the form, just make sure to set the 'Content-Type' header
        return axios.post(API_URL + '/send', formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            },
        });
    }
    generatePdf(formData) {

        // Post the form, just make sure to set the 'Content-Type' header
        return axios.post(API_URL + '/pdf', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/pdf'
            }, 
            responseType: 'blob',
        });
    }
}

export default new CompletedService
